<template>
    <v-dialog v-model="visible" width="500">
        <template #activator="{}">
            <v-btn color="primary" @click="open">
                {{ $t('einstellungen.dialog.button') }}
            </v-btn>
        </template>
        <Form v-slot="{ meta }">
            <form @submit.prevent="submit">
                <v-card>
                    <FocusLock>
                        <v-card-title class="headline font-weight-bold mb-2">
                            {{ $t('einstellungen.adressedialog.title') }}
                        </v-card-title>
                        <v-card-text class="pb-0">
                            <Field v-slot="{ errors, field }" v-model="teilnehmerCopy.firma" name="Firma" :rules="getValidation('teilnehmerEditApiDto.firma')">
                                <v-text-field
                                    v-bind="field"
                                    v-model="teilnehmerCopy.firma"
                                    autofocus
                                    clearable
                                    :label="$t('einstellungen.adressedialog.firma') + '*'"
                                    :placeholder="$t('einstellungen.adressedialog.firma')"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <Field
                                v-slot="{ errors, field }"
                                v-model="teilnehmerCopy.strasse"
                                name="Strasse"
                                :rules="getValidation('teilnehmerEditApiDto.strasse')"
                            >
                                <v-text-field
                                    v-bind="field"
                                    v-model="teilnehmerCopy.strasse"
                                    :label="$t('einstellungen.adressedialog.strasse') + '*'"
                                    :placeholder="$t('einstellungen.adressedialog.strasse')"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <v-text-field
                                v-model="teilnehmerCopy.zusatz"
                                :label="$t('einstellungen.adressedialog.zusatz')"
                                :placeholder="$t('einstellungen.adressedialog.zusatz')"
                            ></v-text-field>
                            <Field v-slot="{ errors, field }" v-model="teilnehmerCopy.plz" name="Plz" :rules="getValidation('teilnehmerEditApiDto.plz')">
                                <v-text-field
                                    v-bind="field"
                                    v-model="teilnehmerCopy.plz"
                                    :label="$t('einstellungen.adressedialog.plz') + '*'"
                                    :placeholder="$t('einstellungen.adressedialog.plz')"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <Field v-slot="{ errors, field }" v-model="teilnehmerCopy.ort" name="Ort" :rules="getValidation('teilnehmerEditApiDto.ort')">
                                <v-text-field
                                    v-bind="field"
                                    v-model="teilnehmerCopy.ort"
                                    label="Ort*"
                                    placeholder="Ort"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <Field
                                v-slot="{ errors, field }"
                                v-model="teilnehmerCopy.telefon"
                                name="Telefon"
                                :rules="getValidation('teilnehmerEditApiDto.telefon') + '|valid_swiss_telephone_number'"
                            >
                                <v-text-field
                                    v-bind="field"
                                    v-model="teilnehmerCopy.telefon"
                                    :label="$t('einstellungen.adressedialog.telefon') + '*'"
                                    :placeholder="$t('einstellungen.adressedialog.telefon')"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <Field v-slot="{ errors, field }" v-model="teilnehmerCopy.email" name="Email" :rules="getValidation('teilnehmerEditApiDto.email')">
                                <v-text-field
                                    v-bind="field"
                                    v-model="teilnehmerCopy.email"
                                    :label="$t('einstellungen.adressedialog.email') + '*'"
                                    :placeholder="$t('einstellungen.adressedialog.email')"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <v-text-field
                                v-model="teilnehmerCopy.bemerkungen"
                                :label="$t('einstellungen.adressedialog.bemerkung')"
                                :placeholder="$t('einstellungen.adressedialog.bemerkung')"
                            ></v-text-field>
                        </v-card-text>

                        <v-card-actions class="ml-4">
                            <v-btn :disabled="!meta.valid" color="primary" type="submit" variant="flat" class="modalbutton mb-3">
                                {{ $t('components.dialog.save') }}
                            </v-btn>
                            <v-btn class="modalbutton mb-3" variant="flat" @click="visible = false">
                                {{ $t('components.dialog.cancel') }}
                            </v-btn>
                        </v-card-actions>
                    </FocusLock>
                </v-card>
            </form>
        </Form>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

import { namespace } from 'vuex-facing-decorator';

import { Form, Field } from 'vee-validate';

import { NAME as NAME_EINSTELLUNGEN } from '../store';
const profilModul = namespace(NAME_EINSTELLUNGEN);

import { NAME as NAME_VALIDATION } from '@/store/modules/validation';
const validationModul = namespace(NAME_VALIDATION);

import { EDIT_ADRESSE } from '../store/actions';
import { GET_VALIDATION_KEY } from '@/store/modules/validation/getters';

import { TeilnehmerApiDto, TeilnehmerEditApiDto } from '@/api-schema';

@Component({
    components: {
        Form,
        Field
    }
})
export default class EditAdresseDialog extends Vue {
    @Prop({ required: true, type: Object })
    private editTeilnehmer!: TeilnehmerApiDto;

    private visible = false;
    private teilnehmerCopy: TeilnehmerEditApiDto = {
        bemerkungen: '',
        email: '',
        firma: '',
        ort: '',
        strasse: '',
        telefon: '',
        zusatz: '',
        rowVersion: ''
    };

    @profilModul.Action(EDIT_ADRESSE) edit!: Function;
    @validationModul.Getter(GET_VALIDATION_KEY) getValidation!: (key: string) => string;

    private onSave() {
        this.edit(this.teilnehmerCopy).then(() => {
            this.visible = false;
            this.$emit('success');
        });
    }

    submit() {
        this.onSave();
    }

    private open() {
        this.$emit('open');
        this.teilnehmerCopy.kundenNummer = this.editTeilnehmer.kundenNummer;
        this.teilnehmerCopy.email = this.editTeilnehmer.email;
        this.teilnehmerCopy.firma = this.editTeilnehmer.firma;
        this.teilnehmerCopy.ort = this.editTeilnehmer.ort;
        this.teilnehmerCopy.strasse = this.editTeilnehmer.strasse;
        this.teilnehmerCopy.telefon = this.editTeilnehmer.telefon;
        this.teilnehmerCopy.zusatz = this.editTeilnehmer.zusatz;
        this.teilnehmerCopy.plz = this.editTeilnehmer.plz;
        this.teilnehmerCopy.rowVersion = this.editTeilnehmer.rowVersion;

        this.visible = true;
    }
}
</script>
